module.exports = __webpack_public_path__ + "assets/img/dingyue.215b63a5.png";